import { isAvailable } from '@setapp/desktop-app-helper';
import BasePage from '../../components/base-page/base-page';
import Carousel from '../../components/carousel/carousel';
import Switcher from '../../components/switcher/switcher';
import config from '../../../shared/config/config';
import request from '../../utils/request/request';
import getInstallerUrl from '../../utils/installer-url/installer-url';
import VideoModal from '../../components/video-modal/video-modal';
import jump from '../../utils/jump';

import './application.scss';
import breakpoints from '../../config/breakpoints';

class ApplicationPage extends BasePage {
  ui = {
    screenshotSlider: '.js-app-screenshots',
    setappPromoSection: '.js-setapp-promo-section',
    pageContainer: '.js-application-page',
    featureSection: '.js-application-page-features',
    seeMoreLink: '.js-jump-to-features',
    caseSwitcher: '.js-switcher',
  };

  uiCollections = {
    ctaButtons: '[data-cta-button]',
  };

  events = {
    'click @uiCollections.ctaButtons': 'handleCtaButtonClick',
    'click @ui.seeMoreLink': 'scrollToFeaturesSection',
  };

  isUserLoggedIn = false;

  isSetappAvailable = false;

  appId = null;

  appAutoLaunch = null;

  requestInstallerLinkPromise = null;

  onInit() {
    super.onInit();

    this.initSwitcher();

    this.appId = this.ui.pageContainer.dataset.appId || null;
    this.appAutoLaunch = this.ui.pageContainer.dataset.appAutoLaunch || null;
    this.isUserLoggedIn = this.ui.pageContainer.dataset.isUserLoggedIn || false;
    this.isExclusive = this.ui.pageContainer.dataset.isAppExclusive || false;

    if (this.isUserLoggedIn) {
      this.requestInstallerLinkPromise = this.requestInstallerLink(this.appId);
    }

    isAvailable({ onSuccess: this.handleDesktopAvailable, onError: this.handleDesktopNotAvailable });

    this.screenshotsCarousel = new Carousel({
      rootElement: this.ui.screenshotSlider,
      loop: false,
      slidesPerPage: {
        [breakpoints.lg]: 2,
      },
    });
    this.screenshotsCarousel.init();

    this.videoModal = new VideoModal();
    this.videoModal.init();
  }

  initSwitcher() {
    this.screenshotsSwitcher = new Switcher({ rootElement: this.ui.caseSwitcher });
    this.screenshotsSwitcher.init();
  }

  scrollToFeaturesSection = (e) => {
    e.preventDefault();
    jump(this.ui.featureSection, {
      offset: -100, // sticky navigation height margin
    });
  }

  handleDesktopAvailable = () => {
    this.isSetappAvailable = true;

    if (this.appAutoLaunch) {
      this.launchSetapp(this.appId);
    }

    this.updateCtaButtons(this.uiCollections.ctaButtons);
  };

  handleDesktopNotAvailable = () => {
    this.isSetappAvailable = false;
  };

  handleCtaButtonClick = (e) => {
    e.preventDefault();

    if (this.isSetappAvailable) {
      this.launchSetapp(this.appId);
    } else if (this.isUserLoggedIn) {
      this.requestInstallerLinkPromise
        .then((link) => window.location.assign(link))
        .catch((error) => console.error('Couldn\'t get installer link:', error)); // eslint-disable-line no-console
    } else if (this.isExclusive === 'team') {
      window.location.assign(config.get('teamsAccountPages.signup'));
    } else {
      this.signupModal.open();
    }
  };

  updateCtaButtons = (buttons) => {
    buttons.forEach((button) => {
      const {
        ctaButtonDownloadTitle,
        ctaButtonLaunchTitle,
      } = button.dataset;

      if (this.isSetappAvailable) {
        // eslint-disable-next-line no-param-reassign
        button.textContent = ctaButtonLaunchTitle;
      } else {
        // eslint-disable-next-line no-param-reassign
        button.textContent = ctaButtonDownloadTitle;
      }
    });
  };

  launchSetapp = (appId) => {
    window.location.replace(`setapp://launch/${appId}`);
  };

  requestInstallerLink = (appId) => request.get(`${config.get('customerAccountAPI.application')}${appId}`)
    .then((response) => getInstallerUrl(response.installer_url));
}

export default ApplicationPage;

ApplicationPage.initOnDomLoaded();
